import { ACTIVE } from '../../classnames/design-system';
import { SELECTORS } from './constants';

export class NavigationDropdownUI {
  constructor() {
    this.option = document.querySelector(`.${SELECTORS.OPTION}`);
    this.section = document.querySelector(`.${SELECTORS.SECTION}`);
  }

  setExpanded = (isExpanded) => {
    this.option.setAttribute('aria-expanded', isExpanded);
  };

  show = () => {
    this.section.classList.add(ACTIVE);
    this.setExpanded(true);
  };

  hide = () => {
    this.section.classList.remove(ACTIVE);
    this.setExpanded(false);
  };

  contains = (element) => (
    this.option.contains(element) || this.section.contains(element)
  );

  focusOption = () => {
    this.option.focus();
  };

  focusNextOption = () => {
    this.option.nextElementSibling?.focus();
  };
}
